
export enum TGRSoundEvent {
    anticipation_QH = "anticipation_QH",
    anticipation_S = "anticipation_S",
    anticipation_end = "anticipation_end",
    monkeysymbol_animate = "monkeysymbol_animate",
    monkey_fizz = "monkey_fizz",
    monkey_collect = "monkey_collect",
    countup_quickhit_start = "countup_quickhit_start",
    countup_quickhit_end = "countup_quickhit_end",
    freespinsawarded = "freespinsawarded"
}
